// extracted by mini-css-extract-plugin
export default {"heading":"BasicInformation_heading__bhbz9","wrapper":"BasicInformation_wrapper__t5aZY"};